import gql from 'graphql-tag';

const GET_TASK_BY_IDS = gql`
  query getTaskByIds(
    $where: TaskWhereInput
    $orderBy: TaskOrderByInput
    $skip: Int
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    getTaskByIds: tasksConnection(
      where: $where
      orderBy: $orderBy
      skip: $skip
      after: $after
      before: $before
      first: $first
      last: $last
    ) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          name
          createdBy {
            id
            name
            avatar {
              id
              key
            }
            roles {
              id
              org {
                id
                name
                level
              }
            }
          }
        }
      }
      aggregate {
        count
      }
    }
    full: tasksConnection(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export default GET_TASK_BY_IDS;
